import React, { Component } from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import Panel from "../../components/panel/panel";
import { Form, Spin, Descriptions } from "antd";
import { withActions } from "actionware";
import { savePersonalInfo, fetchLenderProfile } from "./profileActions";
import EditablePanelComponent from "./editablePanelComponent";
import { profileItems } from "./metadata";

@connect(({ session, localize, profile: { profileData, userData } }) => ({
  translate: getTranslate(localize),
  profileData,
  userData,
}))
@withActions({
  savePersonalInfo,
  fetchLenderProfile,
})
@Form.create()
export default class PersonalInfo extends EditablePanelComponent {
  componentDidMount() {
    const { userData } = this.props;
    if (!userData) {
      this.props.fetchLenderProfile();
    }
  }

  sendSaveRequest = (values) => {
    return this.props.savePersonalInfo(values);
  };

  onKtpDrop = () => {};

  onNpwpDrop = () => {};

  render() {
    const { translate, userData } = this.props;

    return (
      <Panel
        foldable
        folded
        className={"personal-info"}
        title={translate("profile.personalInformation")}
      >
        {!userData ? (
          <Spin tip={translate("generic.loadingData")} size="large" />
        ) : (
          <Descriptions title="" bordered column={1}>
            {profileItems.map((item) => (
              <Descriptions.Item key={item.key} label={translate(item.label)}>
                {userData[item.key]}
              </Descriptions.Item>
            ))}
          </Descriptions>
        )}
      </Panel>
    );
  }
}
